define('Frontend',['jquery', 'eventManager', 'ANSI/Utility/Dimensions', 'StickyBits', 'ANSI/Utility/SitecoreUtils','promise-polyfill' ], function ($, eventManager, dimensions, stickybits, sitecoreUtils) {

    'use strict';

    function frontEnd() {
    }

    // run any logic before score modules load
    frontEnd.prototype.preload = function () {
        if ( !sitecoreUtils.prototype.isEditing() ) {
            //pattern library dropdown animation
            $('.pattern-library-page .dropdown-toggle').on("click", function () {
                $(this).next('.dropdown-menu').slideToggle(100);
            });

            $('.score-modal').on('show.bs.modal', function () {
                $(this).appendTo('body');
                $('.modal-body').attr('tabindex', '0');
            });
        }
    };

    // run any logic after score modules have loaded
    frontEnd.prototype.postload = function () {
        if ( !sitecoreUtils.prototype.isEditing() ) {
            if ( $('.spotlight-content').length > 0 ) {
                $('.spotlight-content *').each(function (i, el) {
                    $(el).attr('style', '');
                });
            }

            var $scoreSlickSlider = $('.score-slick-slider');
            if ($scoreSlickSlider.length > 0) {
                $(window).resize(function () {
                    $scoreSlickSlider.each(function (i, el) {
                        var elSlick = el.slick;
                        if (elSlick) {
                            elSlick.refresh;
                        }
                    });
                });
            }

            if ( document.querySelector('.member-updates-page') ) {
                if ( dimensions.width > 991 ) {
                    var memberStickyColumn = document.querySelector('.sticky-right-column .score-right');
                    stickybits(memberStickyColumn, { stickyBitStickyOffset: 150 });
                }
            }
            var scrollFormThankYou = function scrollFormThankYou() {
                document.addEventListener("sc-forms-submit-success", function (e) {
                    document.querySelector('.ansi-scroll-button').trigger("click");
                });

            }
            scrollFormThankYou();
        }
    };
    return new frontEnd();
});

//TODO move this logic into it's own module
;
